<template>
  <v-layout wrap>
    <v-flex xs12 md7>
      <v-toolbar elevation="0" dense>
        <v-list class="pb-0">
          <v-list-item class="pa-0">
            <v-list-item-content class="pa-0">
              <v-list-item-title class="title">
                <slot name="title" />
              </v-list-item-title>
              <v-list-item-subtitle>
                <slot name="subtitle" />
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-toolbar>
    </v-flex>
    <v-flex xs12 md5>
      <v-toolbar elevation="0" class="mb-6" dense>
        <v-spacer></v-spacer>
        <v-text-field
          v-if="searchInput"
          v-model="keyword"
          append-icon="mdi-magnify"
          :label="searchLabel"
          dense
          single-line
          hide-details
          class="mt-1 mr-4"
          @keyup.enter="search"
          @click:append="search"
        />
        <slot name="toolbar" />
        <div>
          <v-btn icon @click="add" v-if="btnAdd">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn icon @click="filter" v-if="btnFilter">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn icon @click="upload" v-if="btnUpload">
            <v-icon>mdi-upload</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn icon @click="download" v-if="btnDownload">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn icon @click="reload" v-if="btnReload">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </div>
      </v-toolbar>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'HeaderTabel',
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    searchInput: {
      type: Boolean,
      default: true,
    },
    searchLabel: {
      type: String,
      default: 'Cari Data',
    },
    btnFilter: {
      type: Boolean,
      default: true,
    },
    btnReload: {
      type: Boolean,
      default: true,
    },
    btnAdd: {
      type: Boolean,
      default: true,
    },
    btnUpload: {
      type: Boolean,
      default: false,
    },
    btnDownload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyword: '',
    };
  },
  methods: {
    search() {
      this.$emit('search', this.keyword);
    },

    filter() {
      this.$emit('filter');
    },

    reload() {
      this.$emit('reload');
    },

    add() {
      this.$emit('add');
    },

    upload() {
      this.$emit('upload');
    },

    download() {
      this.$emit('download');
    },
  },
};
</script>
